import { render } from "./End.vue?vue&type=template&id=ed4270de&scoped=true&bindings={}"
import script from "./End.vue?vue&type=script&lang=js"
export * from "./End.vue?vue&type=script&lang=js"

import "./End.vue?vue&type=style&index=0&id=ed4270de&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ed4270de"

export default script